export * from './IconRulerGradient';
export { default as IconRulerGradient } from './IconRulerGradient';
